module.exports = __webpack_public_path__ + "img/servicio-penitenciario.72d00425.png";